import React from 'react';
import { AccountDashboardWidgetBaseProps, useStyles } from './AccountDashboardWidgetBase.utils';
import history from '../../../history';
import {IconButton} from '@material-ui/core';
import { Colors } from '../../../styles/Colors';
import {ChevronRight} from '@material-ui/icons';
import classNames from 'classnames';
import PermissionProvider from '../../../components/PermissionProvider/PermissionProvider';
import { usePermissions } from '../../../hooks/usePermissions';
import { PermissionType } from '../../../store/types/Permission';

const AccountDashboardWidgetBase: React.FC<AccountDashboardWidgetBaseProps> = (
{
    children,
    route,
    icon,
    label,
    customWidgetContainerClass,
    customWidgetContentClass,
    permission
}) => {
    const classes = useStyles();
    
    const isHidden = usePermissions(...permission) == PermissionType.Hidden;
    if(isHidden)
    {
        return <></>;
    }

    return (
        <PermissionProvider permission={permission}>
        <div className={classNames(classes.widgetContainer, customWidgetContainerClass)}>
            <div className={classes.widgetHeader}>
                <div className={classes.label}
                    onClick={() => {
                        history.push(route);
                    }}
                >
                    <div className={classes.headerIconContainer}>
                        {icon}
                    </div>
                    <div>
                        {label}
                    </div>
                </div>
                <div>
                    <IconButton
                        size="medium"
                        onClick={() => {
                            history.push(route);
                        }}
                        className={classes.iconButton}
                    >
                        <ChevronRight htmlColor={Colors.Secondary1}/>
                    </IconButton>
                </div>
            </div>
            <div className={classNames(classes.widgetContent, customWidgetContentClass)}>
                {children}
            </div>
        </div>
    </PermissionProvider>);
};

export default AccountDashboardWidgetBase;
